import ActivityCard, { DefaultActivityContent } from "components/ActivityPanel/ActivityCard";
import moment from "moment";
import React from "react";
import { formatWrittenDateTimeUtc } from "utilities";

interface Props {
  activity: server.dto.BankAccountActivity
}

export const BankAccountActivityCard = (props: Props) => {
  const { activity } = props;
  const { timestampUtc, action } = activity;

  const timstampUtcMoment = moment.utc(timestampUtc);

  const title = action.text;
  const subtitles = [`${timstampUtcMoment.fromNow()}`];

  return <ActivityCard
    activity={activity}
    getTitle={() => title}
    getSubtitle={() => subtitles}
    getSubtitleHover={() => formatWrittenDateTimeUtc(timstampUtcMoment)}
  >
    <DefaultActivityContent activity={props.activity} />
  </ActivityCard>
}